import React from 'react';
import { P, ParagraphProps } from '@kizi/core-components';
import { useField } from '@kizi/comparator-core';

export interface LabelWithFieldnameProps extends ParagraphProps {
  label: string;
  options: string;
  selected: string;
  variant: string;
}

export const LabelWithFieldname: React.FC<LabelWithFieldnameProps> = ({
  label,
  options,
  selected,
  variant = 'footnoteRegular',
  ...restProps
}: LabelWithFieldnameProps) => {
  const _options = useField(options);
  const _selected = useField(selected);

  if (!_options || !_options.value || !_selected) {
    return null;
  }

  const parsedOptions = JSON.parse(_options.value + '');

  if (!parsedOptions.length || !_selected.value) return null;

  const currentOption = parsedOptions.find(
    (option) => option.value == _selected.value
  );

  return (
    <P variant={variant} {...restProps}>{`${label} ${
      currentOption?.label || ''
    }`}</P>
  );
};
